import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../components/Loader';
import { getFeaturesList, getPlan, planList, updateFeature } from '../../services/PlanService';
import CommonUtil from '../../util/CommonUtils';
import FeatureSelection from './FeatureSelection';
import LabeledInputToggle from './LabeledInputToggle';

const EditFeaturesDialog = ({ mCode, yCode, ...props }) => {
    const { t } = useTranslation();
    const [features, setfeatures] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [highestSequencId, setHighestSequencId] = useState(0);
    const [memberCount1, setMemberCount1] = useState({
        planName: "",
        memberCount: "",
    });
    const [memberCount2, setMemberCount2] = useState({
        planName: "",
        memberCount: "",
    });
    const [payloadFeatures, setPayloadFeatures] = useState({
        DASHBOARD: [],
        TIMESHEET: [],
        REPORT: [],
        INTEGRATION: [],
        OTHERS: []
    });
    const [isFeatureEnabled, setIsFeatureEnabled] = useState({
        DASHBOARD: false,
        TIMESHEET: false,
        REPORT: false,
        INTEGRATION: false,
        OTHERS: false,
        PROJECT_COUNT: false,
        MEMBER_COUNT: false,
        TAG_COUNT: false,
        DAILY_AI_SUMMARIZATION_LIMITS: false
    });

    const [payloadFeaturesError, setPayloadFeaturesError] = useState({
        DASHBOARD: ['Members Dashboard'],
        TIMESHEET: ["Sundial Time Sheet"],
        REPORT: ['View'],
        INTEGRATION: [],
        OTHERS: ["Multi Language Support"]
    });

    const dashboardOptions = [
        { label: "All", value: "All", isDisable: false },
        { label: "Members Dashboard", value: "Members Dashboard", isDisable: true },
        { label: "Organization Dashboard", value: "Organization Dashboard", isDisable: false },
    ];

    const timesheetOptions = [
        { label: "All", value: "All", isDisable: false },
        { label: "Automatic Project Tagging", value: "Automatic Project Tagging", isDisable: false },
        { label: "In-App Chatbot Support", value: "In-App Chatbot Support", isDisable: true },
        { label: "Sundial", value: "Sundial Time Sheet", isDisable: true },
    ];

    const ReportOptions = [
        { label: "All", value: "All", isDisable: false },
        { label: "View", value: "View", isDisable: true },
        { label: "Export", value: "Export", isDisable: false },
    ];

    const IntegrationOptions = [
        { label: "All", value: "All", isDisable: false },
        { label: "Biotime", value: "BioTime", isDisable: false }
        // { label: "Outlook", value: "Outlook" },
        // { label: "Teams", value: "Teams" },
        // { label: "Calendar", value: "Calendar" },
    ];

    const OthersOptions = [
        { label: "All", value: "All", isDisable: false },
        { label: "Team lead", value: "Team lead", isDisable: false },
        { label: "Multi Language Support", value: "Multi Language Support", isDisable: true },
    ];

    const getOptionBasedOnCode = (code) => {
        if (code === "DASHBOARD") return dashboardOptions;
        if (code === "TIMESHEET") return timesheetOptions;
        if (code === "REPORT") return ReportOptions;
        if (code === "INTEGRATION") return IntegrationOptions;
        if (code === "OTHERS") return OthersOptions;

    }

    const handleToggle = (e, code) => {
        setIsFeatureEnabled({
            ...isFeatureEnabled,
            [code]: e.target.checked
        })
        if (!e.target.checked) {
            let newObject = Object.fromEntries(
                Object.entries(payloadFeatures).filter(([key]) => key !== code)
            );
            setPayloadFeatures({
                ...newObject
            })
        }
    };

    const filterValue = (value, code) => {
        if (value?.includes("All")) {
            const optionValue = getOptionBasedOnCode(code)?.map(option => option.value).filter(option => option != "All");
            return [...optionValue, "All"];
        }
        else return value;
    }

    useEffect(() => {
        const newFeatureEnabled = {};
        const newPayloadFeatures = {};

        props.features?.forEach(element => {
            newFeatureEnabled[element.code] = true;
            newPayloadFeatures[element.code] = filterValue(element.value?.split(",") || [], element.code);
        });

        setIsFeatureEnabled(prevState => ({
            ...prevState,
            ...newFeatureEnabled,
        }));

        setPayloadFeatures(prevState => ({
            ...prevState,
            ...newPayloadFeatures,
        }));
        findHighestSeqIdPlan();
    }, [props.features]);

    const handleClose = () => {
        props.onClose(false);
    };

    const filterValues = (value) => {
        if (value?.includes("All"))
            return "All";
        else return value.join(",")
    }

    useEffect(() => {
        setIsLoading(true);
        getFeaturesList().
            then((res) => {
                if (res?.status === 200 && res?.data?.code === "RCI0000") {
                    setfeatures(res.data.data.features.content);
                } else {
                    setfeatures([]);
                }
                setIsLoading(false);
            });
    }, []);

    const findHighestSeqIdPlan = () => {
        const intervalUnit = 'MONTHS';
        var requestData = {
            intervalUnit
        };
        planList(requestData).then((res) => {
            if (res?.status === 200 && res?.data?.code === "RCI0000") {
                let plan = res.data.data.plans.sort((o1, o2) => o2.planOrder - o1.planOrder)[0].planOrder;
                setHighestSequencId(plan)
                loadPlanBySequence(plan);
            }
        });
    }

    const extractFeatureDetails = (data) => {
        return data?.featureDetails?.map((item) => {
            if (item.feature.code === "MEMBER_COUNT") {
                return item.value;
            }
        });
    };

    const callplans = (order, callback) => {
        getPlan(order)
            .then((res) => {
                if (res?.status === 200 && res?.data?.code === "RCI0000") {
                    callback(res.data.data);
                }
            })
            .catch((error) => {
                console.error("Error in getPlan request:", error);
            });
    }

    const loadPlanBySequence = (seqId) => {
        if (Math.abs(props.currentPlanOrder) == 0) {
            callplans(1, (data) => {
                const memberCount = extractFeatureDetails(data).filter(f => f !== undefined);
                setMemberCount1({
                    planName: data.plansDetails[0].name,
                    memberCount: memberCount[0]
                });

            });
        }
        else if (Math.abs(props.currentPlanOrder) == seqId) {
            callplans((seqId - 1), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
               
                setMemberCount1({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
        } else {
            callplans((Math.abs(props.currentPlanOrder) - 1), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
                
                setMemberCount1({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
            callplans((Math.abs(props.currentPlanOrder) + 1), (data) => {
                const mc = extractFeatureDetails(data).filter(f => f !== undefined);
               
                setMemberCount2({
                    planName: data.plansDetails[0].name,
                    memberCount: mc[0]
                });

            });
        }

    }

    const validateFeaturesFields = () => {
        
        if (payloadFeatures?.PROJECT_COUNT != undefined && payloadFeatures?.PROJECT_COUNT?.length > 0) {
            if (payloadFeatures.PROJECT_COUNT <= 0 ||
                payloadFeatures.PROJECT_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    PROJECT_COUNT: t("RAL0809")
                });
                return false;
            }
        }

        if (payloadFeatures?.MEMBER_COUNT == undefined || payloadFeatures?.MEMBER_COUNT?.length == 0) {
            setPayloadFeaturesError({
                ...payloadFeaturesError,
                MEMBER_COUNT: t("RAL0806")
            });
            return false;
        }
        if (payloadFeatures?.MEMBER_COUNT != undefined && payloadFeatures?.MEMBER_COUNT?.length > 0) {
            if (payloadFeatures.MEMBER_COUNT <= 0 ||
                payloadFeatures.MEMBER_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: t("RAL0807")
                });
                return false;
            }
        }

        if (Math.abs(props.currentPlanOrder) == 0) {
            if (Math.abs(payloadFeatures.MEMBER_COUNT[0]) > Math.abs(memberCount1.memberCount)) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: `${memberCount1.planName} has ${memberCount1.memberCount} members, please select a lesser value.`
                });
                return false;
            }
        }
        else if (Math.abs(props.currentPlanOrder) == highestSequencId) {
            if (Math.abs(payloadFeatures.MEMBER_COUNT[0]) < Math.abs(memberCount1.memberCount)) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: `${memberCount1.planName} has ${memberCount1.memberCount} members, please select a greater value.`
                });
                return false;
            }
        } else {
            if (Math.abs(payloadFeatures.MEMBER_COUNT[0]) < Math.abs(memberCount1.memberCount)
                || Math.abs(payloadFeatures.MEMBER_COUNT[0]) > Math.abs(memberCount2.memberCount)
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    MEMBER_COUNT: `The member count must be between ${memberCount1.memberCount} and ${memberCount2.memberCount}`
                });
                return false;
            }
        }


        if (payloadFeatures?.TAG_COUNT != undefined && payloadFeatures?.TAG_COUNT?.length > 0) {
            if (payloadFeatures.TAG_COUNT <= 0 ||
                payloadFeatures.TAG_COUNT > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    TAG_COUNT: t("RAL0810")
                });
                return false;
            }
        }
        if (payloadFeatures?.DAILY_AI_SUMMARIZATION_LIMITS != undefined &&
            payloadFeatures?.DAILY_AI_SUMMARIZATION_LIMITS?.length > 0) {
            if (payloadFeatures.DAILY_AI_SUMMARIZATION_LIMITS <= 0 ||
                payloadFeatures.DAILY_AI_SUMMARIZATION_LIMITS > 10000
            ) {
                setPayloadFeaturesError({
                    ...payloadFeaturesError,
                    DAILY_AI_SUMMARIZATION_LIMITS: t("RAL0811")
                });
                return false;
            }
        }
        return true;
    }

    const handleSubmit = () => {

        if (!validateFeaturesFields()) {
            return;
        }

        const features1 = []
        Object.entries(payloadFeatures)?.map(pFeature => {
            features.forEach(ftr => {
                if (ftr.code == pFeature[0] && pFeature[1]?.length !== 0) {
                    features1.push({
                        feature_Id: ftr.id,
                        value: filterValues(pFeature[1])
                    })
                }
            })
        })
        setIsLoading(true);
        updateFeature(mCode, yCode, features1).then((res) => {
            setIsLoading(false);
            props.onSubmit(res?.data)
        });
    };
    return (
        <Dialog open={props.open}
            sx={{
                "& .MuiDialog-paper": {
                    width: "80% !important",
                    maxWidth: "65% !important",
                    background: "#FFFFFF"
                }
            }}
        >
            <DialogTitle className='dailogbox-container' style={{ marginBottom: "15px" }}>
                {/* {"Edit feature"} */}
                Edit
                <p
                    style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "300px",
                        font: "inherit",
                        textAlign: "center",
                        margin: "0 7px"
                    }}
                >
                    {localStorage.getItem("plan_name")}
                </p>
                feature
            </DialogTitle>
            <Divider sx={{ width: "95%", border: "1px solid #D9D9D9", mx: "auto" }} />
            <DialogContent>
                {isLoading && <Loader open={isLoading} />}
                <div className="FeatureContents">

                    <FeatureSelection title="Dashboard"
                        code={"DASHBOARD"}
                        setPayloadFeatures={setPayloadFeatures}
                        setIsFeatureEnabled={setIsFeatureEnabled}
                        payloadFeatures={payloadFeatures}
                        isFeatureEnabled={isFeatureEnabled}
                        options={dashboardOptions} />

                    <FeatureSelection title="AI Features"
                        code={"TIMESHEET"}
                        setPayloadFeatures={setPayloadFeatures}
                        setIsFeatureEnabled={setIsFeatureEnabled}
                        payloadFeatures={payloadFeatures}
                        isFeatureEnabled={isFeatureEnabled}
                        options={timesheetOptions} />

                    <FeatureSelection title="Report"
                        code={"REPORT"}
                        setPayloadFeatures={setPayloadFeatures}
                        setIsFeatureEnabled={setIsFeatureEnabled}
                        payloadFeatures={payloadFeatures}
                        isFeatureEnabled={isFeatureEnabled}
                        options={ReportOptions} />

                    <FeatureSelection title="Integration"
                        code={"INTEGRATION"}
                        setPayloadFeatures={setPayloadFeatures}
                        setIsFeatureEnabled={setIsFeatureEnabled}
                        payloadFeatures={payloadFeatures}
                        isFeatureEnabled={isFeatureEnabled}
                        options={IntegrationOptions} />

                    <FeatureSelection title="Others"
                        code={"OTHERS"}
                        setPayloadFeatures={setPayloadFeatures}
                        setIsFeatureEnabled={setIsFeatureEnabled}
                        payloadFeatures={payloadFeatures}
                        isFeatureEnabled={isFeatureEnabled}
                        options={OthersOptions} />

                    <LabeledInputToggle
                        code={"PROJECT_COUNT"}
                        label="Project count"
                        placeholder="Enter value"
                        value={payloadFeatures["PROJECT_COUNT"] !== undefined ? payloadFeatures["PROJECT_COUNT"][0] : ""}
                        onChange={(e) => {
                            if (!/^\d*$/.test(e.target.value)) return;
                            if ((e.target.value).length > 5) return;
                            setPayloadFeaturesError({ ...payloadFeaturesError, PROJECT_COUNT: "" })
                            setPayloadFeatures({
                                ...payloadFeatures,
                                PROJECT_COUNT: e.target.value !== "" ? [e.target.value] : []
                            })
                        }}
                        onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
                                e.preventDefault();
                            }
                        }}
                        checked={isFeatureEnabled["PROJECT_COUNT"]}
                        onToggle={(e) => handleToggle(e, "PROJECT_COUNT")}
                        error={payloadFeaturesError.PROJECT_COUNT}
                    />
                    <LabeledInputToggle
                        code={"MEMBER_COUNT"}
                        required={true}
                        label="Member count"
                        placeholder="Enter value"
                        value={payloadFeatures["MEMBER_COUNT"] !== undefined ? payloadFeatures["MEMBER_COUNT"][0] : ""}
                        onChange={(e) => {
                            if (!/^\d*$/.test(e.target.value)) return;
                            if ((e.target.value).length > 5) return;
                            setPayloadFeaturesError({ ...payloadFeaturesError, MEMBER_COUNT: "" })
                            setPayloadFeatures({
                                ...payloadFeatures,
                                MEMBER_COUNT: e.target.value !== "" ? [e.target.value] : []
                            })
                        }}
                        onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
                                e.preventDefault();
                            }
                        }}
                        checked={true}
                        onToggle={(e) => handleToggle(e, "MEMBER_COUNT")}
                        error={payloadFeaturesError.MEMBER_COUNT}
                    />
                    <LabeledInputToggle
                        code={"TAG_COUNT"}
                        label="Tags count"
                        placeholder="Enter value"
                        value={payloadFeatures["TAG_COUNT"] !== undefined ? payloadFeatures["TAG_COUNT"][0] : ""}
                        onChange={(e) => {
                            if (!/^\d*$/.test(e.target.value)) return;
                            if ((e.target.value).length > 5) return;
                            setPayloadFeaturesError({ ...payloadFeaturesError, TAG_COUNT: "" })
                            setPayloadFeatures({
                                ...payloadFeatures,
                                TAG_COUNT: e.target.value !== "" ? [e.target.value] : []
                            })
                        }}
                        onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
                                e.preventDefault();
                            }
                        }}
                        checked={isFeatureEnabled["TAG_COUNT"]}
                        onToggle={(e) => handleToggle(e, "TAG_COUNT")}
                        error={payloadFeaturesError.TAG_COUNT}
                    />
                    <LabeledInputToggle
                        code={"DAILY_AI_SUMMARIZATION_LIMITS"}
                        label="Daily AI summarizations"
                        placeholder="Enter value"
                        value={payloadFeatures["DAILY_AI_SUMMARIZATION_LIMITS"] !== undefined ? payloadFeatures["DAILY_AI_SUMMARIZATION_LIMITS"][0] : ""}
                        onChange={(e) => {
                            if (!/^\d*$/.test(e.target.value)) return;
                            if ((e.target.value).length > 5) return;
                            setPayloadFeaturesError({ ...payloadFeaturesError, DAILY_AI_SUMMARIZATION_LIMITS: "" })
                            setPayloadFeatures({
                                ...payloadFeatures,
                                DAILY_AI_SUMMARIZATION_LIMITS: e.target.value !== "" ? [e.target.value] : []
                            })
                        }}
                        onPaste={(e) => {
                            const pasteData = e.clipboardData.getData("text");
                            if (!/^\d*$/.test(pasteData) || pasteData.length > 5) {
                                e.preventDefault();
                            }
                        }}
                        checked={isFeatureEnabled["DAILY_AI_SUMMARIZATION_LIMITS"]}
                        onToggle={(e) => handleToggle(e, "DAILY_AI_SUMMARIZATION_LIMITS")}
                        showPerUser={true}
                        error={payloadFeaturesError.DAILY_AI_SUMMARIZATION_LIMITS}
                    />
                </div>
            </DialogContent>

            <DialogActions
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}>
                <Box>
                    <button className={"prev-button"} onClick={handleClose}
                    >Cancel</button>
                    <button className="next-button" onClick={() => handleSubmit()}>Save</button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default EditFeaturesDialog
